import React, { useMemo, useState } from 'react';
import styles from './Cookies.module.scss';
import Button from '../button';
import Switcher from '../switcher';
import BottomDrawer, { MyContext } from '../bottomDrawer/BottomDrawer';
import { useLocalStorage } from '@/hooks';

const CookiesContent = ({ functionalValue, analiticalValue, onDismiss, onAgree, onClose }) => {
	const [showSettings, setShowSettings] = useState(false);
	const [isFuctional, setIsFunctional] = useState(functionalValue);
	const [isAnalitical, setIsAnalitical] = useState(analiticalValue);

	return (
		<>
			<div className={styles.cookies}>
				{showSettings && (
					<div className={styles.settings} onClick={e => e.stopPropagation()}>
						<ul className={styles.list}>
							<li className={styles.listItem}>
								<div className={styles.listItemKey}>
									<h4 className={styles.title}>
										Системные (обязательные) файлы cookie. Всегда активны
									</h4>
									<p className={styles.description}>
										Эти файлы необходимы для корректного функционирования сайта и не могут быть
										отключены в наших системах. Вы можете настроить браузер так, чтобы он блокировал
										их или уведомлял вас об их использовании, но в таком случае сайт может работать
										некорректно.
									</p>
								</div>
							</li>
							<li className={styles.listItem}>
								<div className={styles.listItemKey}>
									<h4 className={styles.title}>Функциональные файлы cookie</h4>
									<p className={styles.description}>
										Являются критически важными для работы отдельных страниц сайта и обеспечивают
										работу полезных функций.
									</p>
								</div>
								<Switcher
									checked={isFuctional}
									name='functional'
									onChange={() => setIsFunctional(!isFuctional)}
								/>
							</li>
							<li className={styles.listItem}>
								<div className={styles.listItemKey}>
									<h4 className={styles.title}>Аналитические файлы cookie</h4>
									<p className={styles.description}>
										Могут использоваться для сбора данных о ваших интересах, посещаемых страницах и
										источниках трафика, чтобы оценивать и улучшать работу сайта.
									</p>
								</div>
								<Switcher
									checked={isAnalitical}
									name='analitical'
									onChange={() => setIsAnalitical(!isAnalitical)}
								/>
							</li>
						</ul>
					</div>
				)}
				<div className={styles.agreement}>
					<p className={styles.content}>
						Мы используем файлы cookie для корректной работы сайта и сбора статистики.{' '}
						<u onClick={() => setShowSettings(true)}>Настроить cookie</u>. Нажимая «Принять», вы
						даёте согласие на их обработку в соответствии с политикой обработки файлов cookie.
					</p>
					<div className={styles.btns}>
						{!showSettings ? (
							<Button
								onClick={() => {
									onDismiss();
									onClose();
								}}
								type='defaultBlack'
							>
								Отклонить
							</Button>
						) : (
							<Button onClick={() => setShowSettings(false)} type='defaultBlack'>
								Свернуть
							</Button>
						)}
						<Button onClick={() => onAgree(isFuctional, isAnalitical)} type='primary'>
							Принять
						</Button>
					</div>
				</div>
			</div>
		</>
	);
};

const Cookies = () => {
	const [showCookiesModal, setShowCookiesModal] = useState(true);
	const [cookie, setCookie] = useLocalStorage('fh-cookie', '{}');
	const cookiesAgreement = useMemo(() => JSON.parse(cookie)?.agreement, [cookie]);
	const cookiesSettings = useMemo(() => JSON.parse(cookie)?.settings, [cookie]);

	return (
		<>
			{cookiesAgreement === undefined && (
				<BottomDrawer isOpen={showCookiesModal} onClose={() => setShowCookiesModal(false)}>
					<CookiesContent
						functionalValue={cookiesSettings === undefined ? true : cookiesSettings?.functional}
						analiticalValue={cookiesSettings === undefined ? true : cookiesSettings?.analitical}
						onDismiss={() => {
							setShowCookiesModal(false);
							setCookie(
								JSON.stringify({
									agreement: false,
									settings: {
										functional: false,
										analitical: false,
									},
								}),
							);
						}}
						onAgree={(value1, value2) => {
							setShowCookiesModal(false);
							setCookie(
								JSON.stringify({
									agreement: true,
									settings: {
										functional: value1,
										analitical: value2,
									},
								}),
							);
						}}
					/>
				</BottomDrawer>
			)}
		</>
	);
};

export default Cookies;
